import { axiosApiInstance } from "@/helper/axios";
import { API_PORTAL_URL } from "@/lib/config";
import { IInquiryInsertPayload, IInquiryResponse } from "./inquiryModel";
import { SuccessToast, ErrorToast } from "@/components/toast/Toasts";

export const insertInquiry = async (
  payload: IInquiryInsertPayload,
): Promise<IInquiryResponse> => {
  try {
    const response = await axiosApiInstance.post(
      `${API_PORTAL_URL}/Inquiry/InsertInquiry`,
      payload,
    );
    if (response.status === 201) {
      SuccessToast(response.data?.Details || "Inquiry submitted successfully!");
    }
    return response.data;
  } catch (error: any) {
    const errorMsg = error?.response?.data?.Details || "Something went wrong";
    ErrorToast(errorMsg);
    console.error("Error inserting inquiry:", error);
    throw error;
  }
};
export const inquiryImagesUpload = async (
  id: number,
  images: File[],
): Promise<any> => {
  try {
    const formData = new FormData();
    formData.append("ID", id.toString());
    images.forEach((file) => {
      formData.append("InnerImages", file);
    });

    const response = await axiosApiInstance.post(
      `${API_PORTAL_URL}/Inquiry/InquiryImagesUpload`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );
    return response.data;
  } catch (error: any) {
    const errorMsg = error?.response?.data?.Details || "Image upload failed";
    ErrorToast(errorMsg);
    console.error("Error uploading inquiry images:", error);
    throw error;
  }
};
